import { jsonMember, jsonObject } from 'typedjson';
import { Guid } from '@web/utils';

@jsonObject
export class PublicBrandCosmeticBoxResponse {
  @jsonMember(String)
  public id!: Guid;

  @jsonMember(String)
  public name!: string;

  @jsonMember(String)
  public slug!: string;
}
